import Loading from '@/components/Loading/Loading';

const LoadingContainer = () => (
    <div className="loader-container">
        <Loading />
    </div>
)

export default LoadingContainer;
